import { assoc } from 'ramda';
import { handleActions } from 'redux-actions';

import { pickPayload } from 'app/reducers/helpers';
import { USER_FETCHED } from 'app/features/user/actionTypes';
import { LOCALE_CHANGED } from 'app/features/localization/actionTypes';

const initialState = { locale: 'enUS' };

const user = handleActions(
  {
    [USER_FETCHED]: pickPayload,
    [LOCALE_CHANGED]: (state, { payload }) => assoc('locale', payload, state),
  },
  initialState,
);

export default user;
